// extracted by mini-css-extract-plugin
module.exports = {"div":"Embed_div__1ws_h","selected":"Embed_selected__1-TVT"};